import React, { Component } from 'react'

import ContentEditable from 'react-contenteditable'
import ControlsLikeContainer from 'components/controls-like-container/controls-like-container'

import {
    isMobile,
    ucfirst
} from 'utils'

export default class MessageGroupMessage extends Component {
    componentDidMount() {
        const {
            handleMessageItemMountOrLoad,
            message
        } = this.props

        const userId = message && message.sender_id ? message.sender_id : null

        handleMessageItemMountOrLoad(userId)
    }

    isEditing = _ => {
        const {
            message,
            currentlyEditedComment,
        } = this.props

        return currentlyEditedComment && currentlyEditedComment.id === message.id
    }

    getMessageText = _ => {
        const {
            type,
            message,
            currentlyEditedComment,
            allUsers
        } = this.props

        let messageText = null

        if (type !== 'comment') {
            return message.message_text
        }

        // All the below is just for comments.
        if (this.isEditing()) {
            messageText = currentlyEditedComment.text
        } else {
            messageText = message.text
        }

        messageText = messageText.replace(/<a(\s[^>]*)?>.*?<\/a>/ig, a => {
            if (!a.includes('#mention')) {
                return a
            }

            const rawMentionIds = a.match(/href="#mention-([^"]*")/g)

            if (rawMentionIds) {
                const mentionId = rawMentionIds[0].replace('href="#mention-', '').replace('"', '')

                const user = allUsers[mentionId]

                return user ? `<strong>${user.first_name} ${user.last_name}</strong>` : null
            } else {
                return null
            }
        })

        return messageText
    }

    render() {
        const {
            message,
            isMine,
            index,
            type,
            allUsers,
            formatText,
            likeEntity,
            editComment,
            deleteComment,
            replyEntity,
            saveEditedComment,
            cancelEditComment,
            thisUser,
            isArchived,
            contentRefs,
            isGroup,
            getUserName,
            user,
            handleEditCommentChange,
            isActiveSearchResult,
            isReply
        } = this.props

        const isEditing = this.isEditing()

        const showUserNameOnMobile = isMobile() && !isMine && index === 0 && type === 'message'

        let messageText = this.getMessageText()

        let messageClassName = 'message-content controls-container-container' // I know, but it IS a container of a container.

        if (isEditing) {
            messageClassName += ' edited'
        }

        if (isActiveSearchResult) {
            messageClassName += ' active-search-result'
        }

        // linkify isn't bringing the goods, so we'll do our own target _blank here.
        const formattedMessageText = (() => {
            if (isActiveSearchResult) {
                const variations = [
                    isActiveSearchResult,
                    isActiveSearchResult.toUpperCase(),
                    isActiveSearchResult.toLowerCase(),
                    ucfirst(isActiveSearchResult),
                ]

                variations.forEach(variation => {
                    messageText = messageText.replace(variation, `<span class="active-search-result-word">${variation}</span>`)
                })
            }

            if (isEditing) {
                return messageText
            }

            return formatText(messageText)
        })()

        return (
            <div
                key={index}
                className={messageClassName}
                id={'message-group-' + message.id}
                ref={ref => {
                    if (isActiveSearchResult) {
                        window.activeMessage = ref
                    }
                }}
            >
                {
                    (showUserNameOnMobile && isGroup) &&
                    getUserName(user)
                }
                {isReply ?
                    <span className='replying-to-name'>
                        {getUserName(message.user)}
                    </span>
                    : null}
                <div>
                    <ContentEditable
                        className="needsclick"
                        ref={ref => { contentRefs[message.id] = ref }}
                        onChange={handleEditCommentChange}
                        html={formattedMessageText}
                        disabled={!isEditing}
                    />
                    {((type === 'comment' || !isMine) && !isReply) ?
                        <ControlsLikeContainer
                            likeCallback={_ => {
                                if (!isArchived) {
                                    likeEntity(message, type)
                                }
                            }}
                            likersIds={message.likersIds}
                            allUsers={allUsers}
                            thisUser={thisUser}
                            isEditing={isEditing}
                            isArchived={isArchived}
                            canEdit={(isMine && message.id)}
                            canReply
                            editCallback={_ => editComment(message)}
                            deleteCallback={_ => deleteComment(message)}
                            saveCallback={saveEditedComment}
                            cancelCallback={cancelEditComment}
                            replyCallback={_ => replyEntity(message)}
                        />
                        : null}
                </div>
            </div>
        );
    }
}
